import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import CADViewer from './CADViewer/CADViewer';

import noPlan from './noplan.svg';

const API_TOKEN = 'NnXzzgHXVM0L_Zj17bQ5mXM<9{S1=';

function App() {
  const params = queryString.parse(window.location.search);
  const apiToken = `${params.apiToken}`;
  const branchId = `${params.branchId}`;
  const zoomToDevice = `${params.zoomToDevice}`;
  const currentFloorPlanName = params.floorPlanName;
  const passSystemAddress = `${params.passSystemAddress}`;
  const failSystemAddress = `${params.failSystemAddress}`;

  const Invokefunction = (cadFileName, zoomToDevice, deviceData) => {
    if (!document.getElementById('CADViewerCanvas')) {
      setTimeout(() => {
        Invokefunction(cadFileName, zoomToDevice, deviceData);
      }, 1000);
      return;
    }
    ReactDOM.render(
      <React.StrictMode>
        <CADViewer
          fileName={cadFileName}
          zoomToDevice={zoomToDevice}
          deviceData={deviceData}
          failSystemAddress={failSystemAddress}
          passSystemAddress={passSystemAddress}
          id="CADViewerComponent"
        />
      </React.StrictMode>,
      document.getElementById('CADViewerCanvas'),
    );
  };

  useEffect(() => {
    if (apiToken !== API_TOKEN) {
      return;
    }
    Invokefunction(currentFloorPlanName, zoomToDevice, {});
  }, [currentFloorPlanName, zoomToDevice]);
  console.log(currentFloorPlanName, typeof currentFloorPlanName);
  return (
    <div className="App">
      {apiToken === API_TOKEN ? (
        !currentFloorPlanName ? (
          <div
            style={{
              flex: 1,
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <img src={noPlan} alt="No floorplan data" />
            This node doesn't have a Floorplan file.
          </div>
        ) : (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100vh',
              zIndex: 9999,
              background: 'white',
              overflow: 'hidden',
            }}
          >
            <div id="CADViewerCanvas">Loading Floorplan..</div>
          </div>
        )
      ) : (
        <h2>Unauthorized</h2>
      )}
    </div>
  );
}

export default App;
